module.exports = "img/button-text-formatting.3818146.svg";